/**
 *
 * @param {SubmitEvent} e
 * @returns {FunnelMainSubmitData}
 */
export function getDataFromSubmitEvent(e) {
  const form = /** @type {HTMLFormElement} */ (e.target)

  if (!form) {
    return {}
  }

  const elements = /** @type {HTMLFormElement[]} */ (
    Array.from(form.querySelectorAll('[name]') || [])
  )

  if (!elements || elements.length === 0) {
    return {}
  }

  const detail = elements.reduce((d, element) => {
    if (!element || !element.name) {
      return d
    }
    d[element.name] = element.value || ''
    return d
  }, /** @type {{ [key: string]: string }} */ ({}))

  return {
    addresses: detail.addresses || '',
    addressautocomplete: detail.addressautocomplete || '',
    addressLine: detail.addressLine || '',
    birthdate: detail.birthdate || '',
    city: detail.city || '',
    email: detail.email || '',
    emails: detail.emails || '',
    firstName: detail.firstName || '',
    lastName: detail.lastName || '',
    name: detail.name || '',
    phone: detail.phone || '',
    ssn: detail.ssn || '',
    ssnEncrypted: detail.ssnEncrypted || '',
    ssnMasked: detail.ssnMasked || '',
    state: detail.state || '',
    zipcode: detail.zipcode || '',
    xxTrustedFormCertUrl: detail.xxTrustedFormCertUrl || '',
  }
}
